import { Routes, Route, Navigate } from 'react-router-dom'
import { AppContainer, LoadingSpinner } from '@templatean/shared/components'
import { useAuth } from '@templatean/shared/hooks'
import LoginPage from './pages/LoginPage'
import HomePage from './pages/HomePage'
import TemplatesPage from './pages/TemplatesPage'
import AssetsPage from './pages/AssetsPage'
import AIStudioPage from './pages/AIStudioPage'
import SettingsPage from './pages/SettingsPage'

function App() {
  const { isAuthenticated, isLoading } = useAuth()

  if (isLoading) {
    return <AppContainer loading={true}><LoadingSpinner /></AppContainer>
  }

  if (!isAuthenticated) {
    return <LoginPage />
  }

  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/templates" element={<TemplatesPage />} />
      <Route path="/assets" element={<AssetsPage />} />
      <Route path="/ai-studio" element={<AIStudioPage />} />
      <Route path="/settings" element={<SettingsPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}

export default App